import { appBranding } from '@/lib/features'

export const formatProductName = (product) => {
  if (!product) {
    return ''
  }

  const override =
    appBranding?.isActive && appBranding?.config?.productTypeNames?.[product.toUpperCase()]

  return override || product
}

export const formatProductLogo = (product) => {
  if (!product) {
    return ''
  }

  const override =
    appBranding?.isActive && appBranding?.config?.productTypeLogos?.[product.toUpperCase()]

  return override || product
}
